import React, { useState } from 'react';
import { Card, Table, DatePicker, Button, Space, Tag, Typography } from 'antd';
import { FileExcelOutlined, PrinterOutlined, SearchOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import useAuthStore from '../../store/useAuthStore';
import { getProductionRegister } from '../../api/reports.api';
import { formatQty, formatDate, exportToCSV } from '../../utils/formatters';

const { Text } = Typography;

const ProductionRegisterPage = () => {
  const { user } = useAuthStore();
  const [dates, setDates] = useState([dayjs().startOf('month'), dayjs()]);

  const { data, isLoading } = useQuery({
    queryKey: ['productionRegister', user.plantID, dates],
    queryFn: () => getProductionRegister(user.plantID, { 
      from: dates[0].format('YYYY-MM-DD'), 
      to: dates[1].format('YYYY-MM-DD') 
    }),
    enabled: !!user.plantID
  });

  const columns = [
    { title: 'Date', dataIndex: 'productionDate', key: 'productionDate', render: v => formatDate(v) },
    { title: 'Batch No', dataIndex: 'batchNo', key: 'batchNo', render: v => <Tag color="blue">{v || 'N/A'}</Tag> },
    { title: 'Ready Product', dataIndex: 'productName', key: 'productName' },
    { title: 'Qty Produced', dataIndex: 'productionQty', key: 'productionQty', render: v => <b>{formatQty(v)}</b> },
    { title: 'Entry By', dataIndex: 'entryBy', key: 'entryBy' }
  ];

  
  const expandedRowRender = (record) => {
    const consumptionColumns = [
      { title: 'Raw Material', dataIndex: 'rawName', key: 'rawName' },
      { title: 'Quantity Used', dataIndex: 'consumptionQty', key: 'consumptionQty', render: (v, r) => `${formatQty(v)} ${r.unitDisplay}` },
      { title: 'Wastage', dataIndex: 'wastageQty', key: 'wastageQty', render: v => <Text type="danger">{formatQty(v)}</Text> },
    ];

    return (
      <Table 
        columns={consumptionColumns} 
        dataSource={record.consumptionDetails || []} 
        pagination={false} 
        size="small" 
        bordered
      />
    );
  };

  return (
    <Card title="Production Register">
      <div style={{ marginBottom: 16 }}>
        <Space className="no-print" wrap>
          <DatePicker.RangePicker 
            value={dates} 
            onChange={(val) => setDates(val)} 
            format="DD-MM-YYYY"
          />
          <Button icon={<PrinterOutlined />} onClick={() => window.print()}>
            Print
          </Button>
          <Button 
            icon={<FileExcelOutlined />} 
            onClick={() => exportToCSV(data || [], columns, 'Production_Register')}
          >
            Export CSV
          </Button>
        </Space>
      </div>

      <Table 
        dataSource={data || []} 
        columns={columns} 
        loading={isLoading} 
        rowKey="pid"
        expandable={{ expandedRowRender }}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </Card>
  );
};

export default ProductionRegisterPage;